import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import eye from "../../assets/eye.png";
import hide from "../../assets/hide.png";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/slice/authSlice";
import { toast } from "react-toastify"; // 🆕 Toastify import

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await dispatch(loginUser({ values: formData }));
    setLoading(false);

    if (response.payload?.user) {
      navigate("/discover");
    } else {
      toast.error(response.payload || "Login failed. Please try again."); // 🆕 Show error in toast
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}

      <form className="login-box" onSubmit={handleSubmit}>
        <h2>Login</h2>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="inppp"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              className="inppp"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <img
              src={showPassword ? hide : eye}
              alt="Toggle visibility"
              className="password-toggle-icon"
              onClick={togglePasswordVisibility}
            />
          </div>
        </div>

        <div className="forgot-password">Forgot Password?</div>

        <button type="submit" className="login-btn">
          Login
        </button>

        <div className="signup-option">
          Don’t have an account?{" "}
          <span onClick={() => navigate("/signup")}>
            <i>Sign Up</i>
          </span>
        </div>

        <div className="back-option">
          <span onClick={() => navigate("/")}>Back to main</span>
        </div>
      </form>
    </div>
  );
};

export default Login;
